var map = {
	"./flags/en.svg": 964,
	"./flags/es.svg": 965,
	"./flags/fr.svg": 966,
	"./flags/it.svg": 967,
	"./flags/nl.svg": 968,
	"./flags/pt.svg": 969,
	"./icons/icon-arrow-down.svg": 145,
	"./icons/icon-arrow-up.svg": 146,
	"./icons/icon-beach--green.svg": 970,
	"./icons/icon-beach--red.svg": 971,
	"./icons/icon-beach.svg": 972,
	"./icons/icon-break.svg": 973,
	"./icons/icon-chevron-circle-left--white.svg": 974,
	"./icons/icon-chevron-circle-left.svg": 975,
	"./icons/icon-chevron-circle-right--white.svg": 976,
	"./icons/icon-chevron-circle-right.svg": 977,
	"./icons/icon-chevron-left--white.svg": 978,
	"./icons/icon-info--circle.svg": 979,
	"./icons/icon-legend-buoys.svg": 980,
	"./icons/icon-legend-star.svg": 981,
	"./icons/icon-legend-swell-arrow.svg": 982,
	"./icons/icon-legend-swell.svg": 983,
	"./icons/icon-legend-wind.svg": 984,
	"./icons/icon-loader.svg": 985,
	"./icons/icon-point--green.svg": 986,
	"./icons/icon-point--red.svg": 987,
	"./icons/icon-point.svg": 988,
	"./icons/icon-reef--green.svg": 989,
	"./icons/icon-reef--red.svg": 990,
	"./icons/icon-reef.svg": 991,
	"./icons/icon-river--green.svg": 992,
	"./icons/icon-river--red.svg": 993,
	"./icons/icon-river.svg": 994,
	"./icons/icon-sandbar--green.svg": 995,
	"./icons/icon-sandbar--red.svg": 996,
	"./icons/icon-sandbar.svg": 997,
	"./icons/icon-thumbs-down-solid.svg": 998,
	"./icons/icon-thumbs-up-solid.svg": 999,
	"./icons/icon-tidal-range--blue.svg": 1000,
	"./icons/icon-tide-clock--color.svg": 1001,
	"./icons/icon-tide-needle.svg": 1002,
	"./icons/icon-tide-star.svg": 1003,
	"./logos/apple-logo--black.svg": 1004,
	"./logos/apple-logo--white.svg": 1005,
	"./logos/google-g-logo.svg": 1006,
	"./logos/outside-logo--black.svg": 1007,
	"./logos/outside-logo--white.svg": 1008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 963;